/* eslint-disable react/react-in-jsx-scope */
import { Login } from '@pages';
import { RouteObject } from 'react-router-dom';
import { RulesAndInstructions } from '../pages/RulesAndInstructions';

export const publicRoutes: RouteObject[] = [
  { path: '/public', element: <Login /> },
  { path: '/the-le', element: <RulesAndInstructions /> },
];
